import { gql } from 'apollo-angular';

const GET_PURCHASEPLAN_MIXES = gql`
  query GetPurchaseplanMixes($rfpId: Long!) {
    mixes(rfpId: $rfpId) {
      name
      mixType
      offers
      duration
      pricingType
    }
  }
`;

export default GET_PURCHASEPLAN_MIXES;
